let request = null;

// Asked once per visit. Resolves to null when no offer is running.
export const getWelcomeOffer = () => {
    if (!request) {
        request = fetch('/api/newsletter/welcome-offer')
            .then((response) => (response.ok ? response.json() : { offer: null }))
            .then((data) => data.offer || null)
            .catch(() => null);
    }
    return request;
};

export const offerHeadline = ({ type, value }) => {
    if (type === 'percentage') return `Get ${value}% off your first order`;
    if (type === 'fixed') return `Get £${value} off your first order`;
    return 'Get free delivery on your first order';
};
